<template>
  <!-- 头部 -->
  <div class="report-summary">
    <div class="report-content">
      <div class="report-text">
        <div class="report-title">身体健康信息</div>
        <div class="report-subtitle">营养素深度解析</div>
        <div class="report-title-2">通过先进的生物电感应技术，精准测量您体内各项微量元素的含量</div>
      </div>
      <div class="report-image">
        <img src="../assets/Frame.png" alt="健康报告图标" />
      </div>
    </div>
    <div class="body-title">营养素数据报表</div>
    <NutritionVitalityCard :tabsData="nutritionTabs" comeType="microelement" @item-click="handleNutritionItemClick"/>

  </div>
</template>

<script>
import NutritionVitalityCard from "../components/NutritionVitalityCard";


export default {
  name: "Microelement",
  components: {  NutritionVitalityCard  },


  data() {
    return {
      nutritionTabs: [
        {
          name: "维生素",
          warningCount: 0,
          qualifiedCount: 0,
          items: [],
        },
      ],
      queryParams: {}
    }
  },
  mounted() {
    this.nutritionTabs = this.$route.query.nutritionTabs
    this.queryParams = this.$route.query.queryParams
    console.log(this.queryParams,999)
  },
  methods: {
    handleNutritionItemClick(item) {
      this.$router.push({
        path: "/nutrition",
        query: {
          code: item.code || "",
          title: item.name,
          av: item.av || "",
          ...this.queryParams,
        },
      });
    },
  }

};
</script>

<style scoped>

.report-title{
  width: 300px;
  font-size: 30px;
  color: #333;
  text-align: justify;
  text-align-last: justify;
}
.report-title-2{
  width: 300px;
  text-align: justify;

}
.report-subtitle{
  font-size: 36px;
  color:#0F48C2;
  padding: 20px 0;
  font-weight: bold;
}
.body-title{
  font-size: 30px;
  font-weight: bold;
  margin: 0 30px;
}
.body-title-subtitle {

  font-weight: 400;
  font-size: 23px;
  color: #A4A4A4;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.report-summary {
  width: 100%;
  background-color: #f5f5f5;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 30px;
  padding-bottom: 70px;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
}

.report-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}


.report-text h3 {
  font-weight: 400;
  font-size: 31px;
  color: #000000;
  line-height: 27px;
  letter-spacing: 20px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.report-text h2 {
  font-weight: 600;
  font-size: 40px;
  color: #0050ff;
  line-height: 31px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.report-text p {
  font-weight: 400;
  font-size: 19px;
  color: #959cc3;
  line-height: 27px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.report-content {
  margin-left:60px;
  font-weight: 400;
  font-size: 19px;
  color: #959cc3;
  line-height: 27px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}


.report-image {
  width: 200px;
  height: 200px;
  margin-right: 40px;
}

.report-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.tabs-container {
  display: flex;
  width: 100%;
  border-bottom: 1px solid #e0e3f0;
  margin-top: 20px;
}
.chart-section {
  margin-top: 20px;
  min-height: 100vh;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 15px 0;
  font-size: 31px;
  color: #89899e;
  position: relative;
  cursor: pointer;
  font-weight: 500;
}

.tab-item.active {
  color: #0050ff;
  font-weight: 500;
}

.tab-item.active::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #0050ff;
}
.item-divider {
  width: 100%;
  height: 1px;
  background-color: #dfdfdf;
  margin: 15px 0;
}
.full-health-info-button-container {
  padding: 20px 30px;
  margin: 20px 0;
}
.full-health-info-button-container {
  padding: 20px 30px;
  margin: 20px 0;
}

.full-health-info-button {
  width: 100%;
  height: 90px;
  background-color: #0052d9;
  color: white;
  border: none;
  border-radius: 45px;
  font-size: 32px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 8px rgba(0, 82, 217, 0.2);
  text-decoration: none;
  cursor: pointer;
}
</style>
